document.addEventListener("DOMContentLoaded", () => {
  
  const partners = Array.from(document.querySelectorAll('.row-partners .et_pb_blurb'));

  // Read More
  if(partners) {
    partners.map(partner => {
      const blurbContent = partner.querySelector('.et_pb_blurb_content');
      const linkElem  = partner.querySelector('.et_pb_module_header a');
      
      if(linkElem) {
        const link = linkElem.getAttribute('href');
        const readMore = document.createElement('DIV');
        readMore.innerHTML = `
          <div class="et_pb_button_module_wrapper et_pb_button_1_wrapper  et_pb_module ">
            <a class="et_pb_button et_pb_custom_button_icon et_pb_button_1 button-text et_pb_bg_layout_light" href="${link}" target="_blank" data-icon="$">LEARN MORE</a>
          </div>
        `;
    
        blurbContent.appendChild(readMore);
      }
      
    });
  }
  
  
});


// WEBPACK FOOTER //
// ./src/js/pages/partners.js